import React, {useEffect, useState} from "react"
import {observer} from "mobx-react-lite"
import { singletonFetch } from 'MODULES/singletonFetch'

export default function OpeningDaysCalendarSliderWeeks({
	openingDays
}) {

	return (
		openingDays.map(openingDay => {
			return (
				<div className="mtt-opening-hours__dates--date" key={openingDay.date}>
					<div className="topbar">
						<p>{openingDay.week_day}</p>
						<span>{openingDay.formatted_date}</span>
					</div>
					<p>{openingDay.opening_day_type.formatted_opening_time}</p>
				</div>
			)
		})
	)
}
